import React from 'react';
import { MONTHS } from './calculations/monthlyNeedCalculations.js';

/**
 * Graphique en barres mensuel, en SVG fait main (cohérent avec le reste du module V2,
 * qui n'utilise ni Chart.js ni Recharts), recoloré aux tokens du design system.
 */
const MonthlyBarChart = ({ values, color = '#000a43', unitDecimals = 1 }) => {
  const w = 848, h = 220, pad = 30, barGap = 10;
  const max = Math.max(...values, 1);
  const barW = (w - pad * 2 - barGap * 11) / 12;
  const gradientId = `rw-bar-gradient-${color.replace('#', '')}`;

  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" height={h}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#4f6bd8" />
          <stop offset="100%" stopColor={color} />
        </linearGradient>
      </defs>
      <line x1={pad} y1={h - pad} x2={w - pad} y2={h - pad} stroke="var(--color-surface-highest, #e0e2eb)" />
      {values.map((v, i) => {
        const bh = (v / max) * (h - pad * 2 - 20);
        const x = pad + i * (barW + barGap);
        const y = h - pad - bh;
        return (
          <g key={i}>
            <rect x={x} y={y} width={barW} height={bh} rx="4" fill={`url(#${gradientId})`} />
            <text x={x + barW / 2} y={h - pad + 16} fontSize="11" textAnchor="middle" fill="var(--color-on-surface-var, #5c6270)">{MONTHS[i]}</text>
            {v > 0 && (
              <text x={x + barW / 2} y={y - 6} fontSize="10.5" textAnchor="middle" fill="var(--color-on-surface-var, #5c6270)">
                {v.toFixed(unitDecimals)}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
};

export default MonthlyBarChart;
